/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SageSignupControlPage_QueryVariables = {};
export type SageSignupControlPage_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SageSignupControlPage_viewer">;
    } | null;
};
export type SageSignupControlPage_Query = {
    readonly response: SageSignupControlPage_QueryResponse;
    readonly variables: SageSignupControlPage_QueryVariables;
};



/*
query SageSignupControlPage_Query {
  viewer {
    actualPersonId
    component(name: "sage_signup")
    ...SageSignupControlPage_viewer
    id
  }
}

fragment MissionControlHeader_viewer on Viewer {
  email
  actualPersonId
  firstName
  lastName
  company {
    id
    name
  }
}

fragment SageSignupControlPage_viewer on Viewer {
  id
  ...MissionControlHeader_viewer
  company {
    id
    unlinkedSageCustomers {
      id
      name
    }
  }
  missionControlData {
    sagePSACompanies {
      id
      companyId
      name
      activated
      workatoCustomerId
      createdAt
    }
    companiesWithSageEnabled {
      id
      companyId
      name
      activated
      workatoCustomerId
      createdAt
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "sage_signup"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"sage_signup\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  },
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "activated",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workatoCustomerId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SageSignupControlPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SageSignupControlPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SageSignupControlPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnlinkedSageCustomer",
                "kind": "LinkedField",
                "name": "unlinkedSageCustomers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlSagePSACompanyType",
                "kind": "LinkedField",
                "name": "sagePSACompanies",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlSagePSACompanyType",
                "kind": "LinkedField",
                "name": "companiesWithSageEnabled",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SageSignupControlPage_Query",
    "operationKind": "query",
    "text": "query SageSignupControlPage_Query {\n  viewer {\n    actualPersonId\n    component(name: \"sage_signup\")\n    ...SageSignupControlPage_viewer\n    id\n  }\n}\n\nfragment MissionControlHeader_viewer on Viewer {\n  email\n  actualPersonId\n  firstName\n  lastName\n  company {\n    id\n    name\n  }\n}\n\nfragment SageSignupControlPage_viewer on Viewer {\n  id\n  ...MissionControlHeader_viewer\n  company {\n    id\n    unlinkedSageCustomers {\n      id\n      name\n    }\n  }\n  missionControlData {\n    sagePSACompanies {\n      id\n      companyId\n      name\n      activated\n      workatoCustomerId\n      createdAt\n    }\n    companiesWithSageEnabled {\n      id\n      companyId\n      name\n      activated\n      workatoCustomerId\n      createdAt\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '8cd3cb6c747f05d34dde22b696f88665';
export default node;
